import React from 'react';
import { Router, browserHistory, IndexRedirect, IndexRoute, Route } from 'react-router';

import redirectRoute from '@evdy/web-core/dist/components/redirectRoute';

import App from './components/App';

// Community Components
import WebCommunity from './components/WebCommunity';
import MessageDetails from './components/Messages/MessageDetails';
import ModalDispatcher from './components/ModalDispatcher';
import GetAppInfo from './components/GetAppInfo';
import ObituaryDetails from './components/ObituaryDetails';
import { EventDetailsPage } from './components/Events';
import DonationsDetails from './components/DonationsDetails';

const Routes = (store, history) => {
  return (
    <Router history={history || browserHistory}>
      <Router path="/" component={App}>
        <Route path="/learnmore/get-app-info/:userId/:memorialId" component={GetAppInfo} />
        <Route path="/announcements/:memorialSlug" component={WebCommunity}>
          <IndexRoute component={WebCommunity} />
          <Route path="event-details" component={EventDetailsPage} />
          <Route path="donations" component={DonationsDetails} />
          <Route path="messages">
            <IndexRedirect to="../../:memorialSlug" />
            <Route path=":messageId" component={MessageDetails} />
          </Route>
          <Route path="condolence/:modalName" component={ModalDispatcher} />
          <Route path="obituary" component={ObituaryDetails} />
        </Route>
        {/* <Route path="/r/memorial/:deceasedId" component={WebCommunity}>
          <IndexRoute component={WebCommunity} />
          <Route path="event-details" component={EventDetailsPage} />
          <Route path="donations" component={DonationsDetails} />
          <Route path="messages">
            <IndexRedirect to="../../:memorialSlug" />
            <Route path=":messageId" component={MessageDetails} />
          </Route>
          <Route path="condolence/:modalName" component={ModalDispatcher} />
          <Route path="obituary" component={ObituaryDetails} />
        </Route> */}
        {/* <Route path="/funeral-homes/:country/:state/:citySlug/:homeSlug/:memorialSlug">
          <IndexRoute component={WebCommunity} />
          <Route path="event-details" component={EventDetailsPage} />
          <Route path="donations" component={DonationsDetails} />
          <Route path="obituary" component={ObituaryDetails} />
        </Route> */}
        {/* <Route path="/funeral-homes/:country/:state/:citySlug/:homeSlug/:memorialSlug/messages">
          <IndexRedirect to="../../:memorialSlug" />
          <Route path=":messageId" component={MessageDetails} />
        </Route> */}
        {/* <Route
          path="/funeral-homes/:country/:state/:citySlug/:homeSlug/:memorialSlug"
          component={WebCommunity}
        >
          <Route path="condolence/:modalName" component={ModalDispatcher} />
        </Route> */}
        <IndexRedirect to="/404" />
        {redirectRoute()}
      </Router>
    </Router>
  );
};

export default Routes;
